












import DimensionServices, { DimensionItemDto } from '@/services/dimension';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class DimensionForm5 extends Vue {
  @Prop() dimSyncDefs!: any;
  @Prop() current!: any;
  @Prop() dimFieldList!: DimensionItemDto[];
  dimSrv = new DimensionServices();
  loading: boolean = false;

  @Watch('dimSyncDefs')
  onChange() {}

  dataSource: any[] = [];

  @Watch('current')
  async onCurrentChange() {
    if (this.current === 4 && this.dimSyncDefs.syncMode < 2) {
      this.loading = true;
      let res = await this.dimSrv.excuteSql(this.dimSyncDefs);
      if (res.header.code == 200) {
        this.dataSource = res.payload.results;
      }
      this.loading = false;
    } else {
      this.dataSource = this.dimSyncDefs.inputdataConfig;
    }
  }
}
